// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.half-content-card-modal-gs{
    position: relative;
    width: 50%;
    height: 100%;
    display: block;
    justify-content: center;
    align-items: center;
}
.center-content-card-modal-gs{
    position: relative;
    width: 90%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content-row-host-selected{
    position:relative;
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: red; */
}
.row-host-selected{
    position:relative;
    height: 70%;
    width: 80%;
    border-radius: var(--border-radios-small);
    border: 1px solid var(--border-table-color);
    background-color: rgba(209, 209, 209, 0.281);
    display: flex;
    justify-content: center;
    align-items: center;
}
.text-host-selected{
    position:relative;
    height: 100%;
    width: 90%;;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: var(--txt-color);
    font-size: var(--font-size-xSmall);
}
.delete-host-selected{
    position:relative;
    height: 100%;
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--red-alert);
    font-size: var(--font-size-xSmall);
}
.delete-host-selected:hover{
cursor: pointer;
font-size: var(--font-size-med);
}
.txtdevicesSelected{
    position: relative;
    height: 100%;
    width: 50%;
    color: var(--txt-color);
    font-size: var(--font-size-small);

}`, "",{"version":3,"sources":["webpack://./src/components/excepciones-components/Maintenance/Maintenance-styles/ModalAddHost.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,yCAAyC;IACzC,2CAA2C;IAC3C,4CAA4C;IAC5C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;AACtC;AACA;AACA,eAAe;AACf,+BAA+B;AAC/B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,iCAAiC;;AAErC","sourcesContent":[".half-content-card-modal-gs{\r\n    position: relative;\r\n    width: 50%;\r\n    height: 100%;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.center-content-card-modal-gs{\r\n    position: relative;\r\n    width: 90%;\r\n    height: 90%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.content-row-host-selected{\r\n    position:relative;\r\n    height: 50px;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* background-color: red; */\r\n}\r\n.row-host-selected{\r\n    position:relative;\r\n    height: 70%;\r\n    width: 80%;\r\n    border-radius: var(--border-radios-small);\r\n    border: 1px solid var(--border-table-color);\r\n    background-color: rgba(209, 209, 209, 0.281);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.text-host-selected{\r\n    position:relative;\r\n    height: 100%;\r\n    width: 90%;;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-xSmall);\r\n}\r\n.delete-host-selected{\r\n    position:relative;\r\n    height: 100%;\r\n    width: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--red-alert);\r\n    font-size: var(--font-size-xSmall);\r\n}\r\n.delete-host-selected:hover{\r\ncursor: pointer;\r\nfont-size: var(--font-size-med);\r\n}\r\n.txtdevicesSelected{\r\n    position: relative;\r\n    height: 100%;\r\n    width: 50%;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
